import { render, staticRenderFns } from "./DownLoads.vue?vue&type=template&id=3bf7d427"
import script from "./DownLoads.vue?vue&type=script&lang=js"
export * from "./DownLoads.vue?vue&type=script&lang=js"
import style0 from "./DownLoads.vue?vue&type=style&index=0&id=3bf7d427&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports